var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "el-fade-in-linear" } }, [
    _vm.isSearch
      ? _c("div", { staticClass: "search-box flex-center" }, [
          _c("div", { staticClass: "bg", on: { click: _vm.close } }),
          _c(
            "div",
            { staticClass: "search color-bg-fff flex-center" },
            [
              _c("el-input", {
                staticClass: "margin-left-20 font-16",
                attrs: {
                  placeholder: "请输入关键词进行搜索，如班次、订单、订票等",
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.searchChange.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.searchKey,
                  callback: function ($$v) {
                    _vm.searchKey = $$v
                  },
                  expression: "searchKey",
                },
              }),
              _c(
                "div",
                {
                  staticClass: "search-btn flex-center",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.searchChange.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("img", {
                    staticStyle: { width: "28px", height: "28px" },
                    attrs: { src: require("./static/icon_home_search.png") },
                  }),
                ]
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }